import { InformacionFamiliarData } from 'components/InformacionFamiliar'
import { ResponseRequest, ResponseRequestGeneric } from 'components/Types/GeneralTypes'
import Cargando from 'components/Varios/Cargando'
import React, { useEffect, useMemo, useState } from 'react'
import { FinalizacionAnticipada, ObtenerFamiliaresConDiscapacidad } from './FunctionsSustitutoFamiliar'
import { Row, Col, Table, Card, CardBody } from "reactstrap"
import CardInformacionFamiliarDiscapacidad from './CardInformacionFamiliarDiscapacidad'
import { AccionesSustituto, InformacionTablaSustitutoFamiliar, RespuestaSustituto } from './TypesSustitutoFamiliar'
import TablaHistorialSustitutoFamiliar from './TablaHistorialSustitutoFamiliar'
import ModalVistaPrevia from 'components/Admin/Certificados/ModalVistaPrevia'
import ModalVistaPreviaDocumentos from 'components/Varios/Modals/ModalVistaPreviaDocumentos'
import { GetDocumentVistaPrevia } from 'helpers/files'
import { UserData } from 'components/Sidebar/Sidebar_Principal'
import { authenticationService } from 'services/authentication.service'
import ModalAgregarInformacionSustituto from './ModalAgregarInformacionSustituto'
import { alertService } from 'components/Varios/alert_service'
import ModalConfirmacion from 'components/Varios/Modals/ModalConfirmacion'

type StateSustitutoFamiliar = {
    loading: boolean,
    informacionGeneral: RespuestaSustituto,

}
type StateModalVerDocumento = {
    referencia: string | undefined,
    loading: boolean
}

type StateModalInformacionFamiliar = {
    informacionFamiliarEnModal: InformacionFamiliarData | undefined,
    editarInformacionSustituto?: InformacionTablaSustitutoFamiliar
}

type StateModalConfirmacionFinalizacionAnticipada = {
    idInformacion: number,
    nombreTabla: string
}

export default function SustitutoInformacionFamiliar() {

    const initialState: StateSustitutoFamiliar = {
        loading: false,
        informacionGeneral: {
            historialSustituto: [],
            informacionFamiliar: [],
            acciones: []
        }
    }

    const initialStateModal: StateModalVerDocumento = {
        referencia: undefined,
        loading: false
    }

    const defaultStateModalAgregarCrear: StateModalInformacionFamiliar = {
        informacionFamiliarEnModal: undefined,
        editarInformacionSustituto: undefined
    }


    const defaultStateModalConfirmacion: StateModalConfirmacionFinalizacionAnticipada = {
        idInformacion: -1,
        nombreTabla: ""
    }

    const [informacionSustituto, setinformacionSustituto] = useState<StateSustitutoFamiliar>(initialState);
    const [modalInfo, setmodalInfo] = useState<StateModalVerDocumento>(initialStateModal)



    const [stateCardModal, setstateCardModal] = useState<StateModalInformacionFamiliar>(defaultStateModalAgregarCrear)

    const [stateModalConfirmacion, setstateModalConfirmacion] = useState<StateModalConfirmacionFinalizacionAnticipada>(defaultStateModalConfirmacion)


    async function ObtenerInformacion() {
        setinformacionSustituto({ ...informacionSustituto, loading: true })
        const resultado: ResponseRequestGeneric<RespuestaSustituto> = await ObtenerFamiliaresConDiscapacidad();
        if (resultado.status === 200 && resultado.dataResponse) {
            setinformacionSustituto({ ...informacionSustituto, loading: false, informacionGeneral: resultado.dataResponse })
        }
        else {
            setinformacionSustituto({ ...informacionSustituto, loading: false })
            alertService.error("Ha ocurrido un inconveniente al tratar de obtener información de Sustitución del familiar")
        }
    }

    async function RecargarInformacion() {
        setinformacionSustituto({ ...informacionSustituto, loading: true })
        const resultado: ResponseRequestGeneric<RespuestaSustituto> = await ObtenerFamiliaresConDiscapacidad();
        if (resultado.status === 200 && resultado.dataResponse) {
            setinformacionSustituto({ ...informacionSustituto, loading: false, informacionGeneral: resultado.dataResponse })
            setmodalInfo(initialStateModal)
            setstateCardModal(defaultStateModalAgregarCrear)
            setstateModalConfirmacion(defaultStateModalConfirmacion)
        }
        else {
            setinformacionSustituto({ ...informacionSustituto, loading: false })
            alertService.error("Ha ocurrido un inconveniente al tratar de obtener información de Sustitución del familiar")
        }
    }

    async function FinalizarAnticipadamente(idAsociado: number, nombreTabla: string) {
        // setinformacionSustituto({ ...informacionSustituto, loading: true })
        const resultado: ResponseRequest = await FinalizacionAnticipada(idAsociado, nombreTabla);
        if (resultado.status === 200) {
            alertService.success("Se ha enviado su solicitud de finalización anticipada. Debe esperar respuesta de TH")

            // await RecargarInformacion();
        }
        else {
            // setinformacionSustituto({ ...informacionSustituto, loading: false })
            alertService.error(resultado.errorMessage)
        }
        return resultado.status;
    }


    useEffect(() => {
        ObtenerInformacion()
    }, [])

    const listadoFamiliares = useMemo(() => {

        const { informacionFamiliar, acciones, historialSustituto } = informacionSustituto.informacionGeneral;

        if (informacionFamiliar.length <= 0) {
            return (
                <Col>
                    <div>No tiene familiares con discapacidad.</div>
                </Col>
            )
        }
        const total = informacionFamiliar.length;

        const historialFiltrado = historialSustituto.filter(c => (c.vigencia === "SI" || (c.vigencia === "NO" && c.estado === "INGRESADA")))


        const filasListado = informacionFamiliar.map((fam, indfam) => {
            const accionSustituto: AccionesSustituto | undefined = acciones.find((val) => val.key === fam.iddependientepersona)
            const historialDeFamiliar = historialFiltrado.find(c => c.idPersonaDependiente === fam.iddependientepersona)
            return (
                <tr>
                    <td>
                        {fam.nombres + " " + fam.apellidos}
                    </td>
                    <td className='text-center'>
                        {fam.strNombreParentesco}
                    </td>
                    <td className="accion">
                        <div className="containerbtn">
                            {
                                accionSustituto && accionSustituto.key === fam.iddependientepersona && accionSustituto.value === "AGREGAR" &&
                                <button className="btn " onClick={() => { setstateCardModal({ informacionFamiliarEnModal: fam }) }}>INGRESAR DATOS PARA SUSTITUTO</button>
                            }
                            {
                                !accionSustituto &&
                                <button className="btn" disabled >INGRESAR DATOS PARA SUSTITUTO </button>
                            }
                        </div>

                    </td>
                </tr>
            )
        });


        const infoListado = (
            <Row className="align-items-center">
                <Col xl={6} sm={12} md={12}>
                    <Table bordered stripped className="tblFamiliares">
                        <thead>
                            <tr>
                                <th>FAMILIAR CON DISCAPACIDAD</th>
                                <th>PARENTESCO</th>
                                <th>ACCIONES</th>
                            </tr>
                        </thead>
                        <tbody>
                            {filasListado}
                        </tbody>
                    </Table>
                </Col>

            </Row>
        )



        // return (
        //     <Col md={6} sm={12} key={"cardSustitutoFam " + indfam}>
        //         <CardInformacionFamiliarDiscapacidad
        //             numero={indfam + 1}
        //             informacionFamiliar={fam}
        //             total={total}
        //             accion={accionSustituto}
        //             editarInformacionSustituto={historialDeFamiliar}
        //             onActivarModal={(info, editar) => setstateCardModal({ informacionFamiliarEnModal: info, editarInformacionSustituto: editar })}
        //             onAccion={() => ObtenerInformacion()}
        //         />
        //     </Col>
        // )

        return infoListado;

    }, [informacionSustituto.informacionGeneral])

    async function verDocumento(referencia: string) {

        const datosUsuario: UserData = authenticationService.currentUserValue;
        const url = await GetDocumentVistaPrevia(referencia, datosUsuario.token);
        setmodalInfo({ referencia: url, loading: false })
    }

    const tablaSustitutoFamiliar = useMemo(() => {

        const { historialSustituto, informacionFamiliar } = informacionSustituto.informacionGeneral


        if (historialSustituto.length > 0) {
            return (
                <TablaHistorialSustitutoFamiliar
                    datos={historialSustituto}
                    onClickVerDocumento={verDocumento}
                    titulo={"Registro Información Sustituto Familiar"}
                    onActivarModal={(info, editar) => setstateCardModal({ informacionFamiliarEnModal: info, editarInformacionSustituto: editar })}
                    informacionFamiliar={informacionFamiliar}
                    // FinalizacionAnticipada={async (id, nombre) => await FinalizarAnticipadamente(id, nombre)}
                    FinalizacionAnticipada={async (id, nombre) => setstateModalConfirmacion({ idInformacion: id, nombreTabla: nombre })}
                />
            )
        }
        else if (historialSustituto.length <= 0 && informacionFamiliar.length > 0) {
            return (
                <Row>
                    <Col>
                        <div className="text-center mt-3">No hay información registradada de Sustituto</div>
                    </Col>
                </Row>

            )
        }

    }
        , [informacionSustituto.informacionGeneral.historialSustituto])


    if (informacionSustituto.loading) {
        return (<Cargando />)
    }

    return (
        <div className='content '>
            <Card className="principal ml-auto mr-auto">
                
                <h5 className="title">SUSTITUTO DE PERSONA CON DISCAPACIDAD</h5>
                <CardBody className="main-content">


                    {listadoFamiliares}

                    {tablaSustitutoFamiliar}
                    <ModalVistaPreviaDocumentos
                        show={modalInfo.referencia !== undefined || modalInfo.loading === true}
                        cargandoDatos={modalInfo.loading}
                        onClose={() => setmodalInfo({ referencia: undefined, loading: false })}
                        size={"xl"}
                        urlArchivo={modalInfo.referencia ?? "a"}
                        tituloModal={"Certificado"}

                    />
                    {
                        stateCardModal.informacionFamiliarEnModal !== undefined &&
                        <ModalAgregarInformacionSustituto
                            size='xl'
                            show={stateCardModal.informacionFamiliarEnModal !== undefined}
                            informacionFamiliar={stateCardModal.informacionFamiliarEnModal}
                            onClose={() => setstateCardModal({ informacionFamiliarEnModal: undefined })}
                            editarInformacionSustituto={stateCardModal.editarInformacionSustituto}
                            onAccion={() => RecargarInformacion()}

                        />
                    }
                    <ModalConfirmacion
                        show={stateModalConfirmacion.idInformacion > 0 && stateModalConfirmacion.nombreTabla !== ""}
                        size="md"
                        asyncAccion={true}
                        asyncClose={true}
                        onClose={() => { setstateModalConfirmacion({ nombreTabla: "", idInformacion: -1 }) }}
                        nombreBotonAccion={"Solicitar Finalización"}
                        mensajeConfirmacion={"¿Estás seguro que deseas finalizar anticipadamente la vigencia del certificado?"}
                        hideBotonCerrar={false}
                        asyncOnClick={async () => await FinalizarAnticipadamente(stateModalConfirmacion.idInformacion, stateModalConfirmacion.nombreTabla)}
                        asyncAfterOnClose={async () => await RecargarInformacion()}
                        tituloModal={"Finalización anticipada de certificación sustituto"}
                        nombreBotonAfterOnClose={"Cerrar"}
                        closeAfterAccion={true}
                    />
                </CardBody>
            </Card>
        </div>

    )
}
